import { lazy } from 'react';
import withLoadableComponent from './withLoadableComponent';
import retry from '../utils/webpack/chunkRetry';
export var LoadablePostPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "postpopup" */
        '../PostPopup');
    });
}));
export var LoadableWriterPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "writerpopup" */
        '../WriterPopup');
    });
}));
export var LoadableCommissionEditPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "commissioneditpopup" */
        '../CommissionEditPopup');
    });
}));
export var LoadablePollEditPopup = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "polleditpopup" */
        '../PollEditPopup');
    });
}));
export var LoadableAddToGroupsPanel = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "addtogroupspanel" */
        '../AddToGroupsPanel');
    });
}));
export var LoadableCollectionModal = withLoadableComponent(lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "collectionpanel" */
        '../CollectionPanel'
        // CollectionModal isn't the default export from CollectionPanel
        ).then(function (module) { return ({ default: module.CollectionModal }); });
    });
}));
//# sourceMappingURL=LoadableModals.js.map